import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import YourVisionOurRoadmap from "./sections/YourVisionOurRoadmap";
import ComprehensiveLaunchSolutions from "./sections/ComprehensiveLaunchSolutions";
import StreamlineYourOperations from "./sections/StreamlineYourOperations";
import VendorProcurementExcellence from "./sections/VendorProcurementExcellence";
import SeamlessClientCoordination from "./sections/SeamlessClientCoordination";
import TechSolutionsTailoredForYou from "./sections/TechSolutionsTailoredForYou";
import ContactSection from "./sections/ContactSection";
import ContactUs from "./sections/ContactUs";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <YourVisionOurRoadmap />
      <ComprehensiveLaunchSolutions />
      <StreamlineYourOperations />
      <VendorProcurementExcellence />
      <SeamlessClientCoordination />
      <TechSolutionsTailoredForYou />
      <ContactSection />
      <ContactUs />
      <Footer />
    </div>;
}